import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { appContext, loadAction } from '../../util/decorators';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import loadDataSources from '../../action/loadDataSources';
import loadSelectedTemplates from '../../action/loadSelectedTemplates';
import Loader from '../Loader.jsx';
import StandardNews from './StandardNews.jsx';
import DualNews from './DualNews.jsx';
import TripleNewsBoxEm from './TripleNewsBoxEm.jsx';
import BigNewsFirstItem from './BigNewsFirstItem.jsx';
import AlternatingNews from './AlternatingNews.jsx';
import NewsFeedHeading from './NewsFeedHeading.jsx';
import ArticleList from './ArticleList.jsx';
//import PageWithSidebars from '../Page/PageWithSidebarsEm.jsx';
import PageWithoutSidebarsEm from '../Page/PageWithoutSidebarsEm.jsx';
import translateRouteParams from '../../util/translateRouteParams.js';
import newsFeedConfig from '../../config/newsFeed.json';
import LeagueWidgetsRow from './LeagueWidgetsRow.jsx';
import competitionToStageMapping from '../../config/competitionToStageMapping.json';
import InfiniteScrollLoader from '../InfiniteScrollLoader';
import NewsFeedMeta from './NewsFeedMeta';
import FeedContainerText from './FeedContainerText.jsx';
//import FeedContainerBox from './FeedContainerBox.jsx';
import TabMenu from '../Navigation/TabMenu';
import VideoList from '../Video/VideoList';


import PageHeading from '../PageHeading.jsx';

const euro2020routeParams = {"sports":"fodbold","competitions":"em"};
// the data source to lazy load new items from when infinity scrolling
const getNewsFeedConfig = (euro2020routeParams, country) => {
  return newsFeedConfig[country]['emfodbold'];
};

const mapStateToProps = state => ({
  manualArticles: state.dataSources.manualArticles,
  selectedTemplates: state.selectedTemplates,
  country: state.country,
  language: state.language,
  // Datasources is used in linkTag2Initializer to see if there are more ads..
  dataSources: state.dataSources,
});

const loadContent = args => {
const config = getNewsFeedConfig(euro2020routeParams, 'dk');
  return loadDataSources({
    ...args,
    dataSourceConfigs: {
      manualArticles: {
        provider: 'viasport',
        config: {
          method: 'manual',
          manualList: config ? config.manualList : null,
        },
      },
    },
    limit: {
      manualArticles: 50,
    },
  });
};

@connect(mapStateToProps)
@loadAction(loadContent)
@loadAction(loadSelectedTemplates)
@linkTag2Initializer('frontpage')
@appContext
export default class Euro2020NewsFeedPage extends React.PureComponent {

  static defaultProps = {
    activeSection: 'startpage',
  }

  constructor(props) {
    super(props);
    this.state = {
      activeSection: props.activeSection,
    };
  }

  componentDidUpdate(previousProps) {

  }
  
  	componentDidMount() {
		
	}


  render() {
    const {manualArticles, selectedTemplates, country, language} = this.props;
    const { activeSection } = this.state;
	//console.log(` routeParams render euro2020:  ` +  JSON.stringify(routeParams));
    //{"sports":"fodbold","competitions":"champions-league"}
    //const feedConfig = getNewsFeedConfig(routeParams, country);
    const feedConfig = getNewsFeedConfig(euro2020routeParams, country);
        const templateKey = feedConfig && feedConfig.templateId;
    const templateConf = _.find(selectedTemplates, { page: templateKey }) || {};
    let selectedTemplate = _.last((templateConf.template || '').split('.'));
   

    
    	const allArticles = _.uniqBy(manualArticles, 'id');
    
    	const emlogo = require(`../../../assets/uefa-logo.jpg`);
    	const euro_2020_website_banners_copenhagen = require(`../../../assets/euro_2020_website_banners_copenhagen.png`);
    	const euro_2020_website_banners_1_v2 = require(`../../../assets/Euro_2020_Website_Banners_1_v2.png`);
    	//const euro_2020_ticketing = require(`../../../assets/UEFA_EURO2020_Ticketing-Ad-ApplyNow_DA_1440_250.jpg`);
    	const logo_alipay = require(`../../../assets/logo_alipay.png`);
    	const logo_FedEx = require(`../../../assets/logo_fedex.png`);
    	const logo_Booking = require(`../../../assets/logo_booking.png`);
    	const logo_Heineken = require(`../../../assets/logo_heineken.png`);
    	const logo_Hisense = require(`../../../assets/logo_hisense.png`);
    	const logo_Socar = require(`../../../assets/logo_socar.png`);
    	const logo_Take_away = require(`../../../assets/logo_Take-away_2.png`);
    	const logo_Volkswagen = require(`../../../assets/logo_Volkswagen.png`);
    	
    	const den_930_180 = require(`../../../assets/den_930_180.png`);
    
    let pageBody;
    let topView;
    if (!_.isEmpty(allArticles)) {
     	pageBody = <TripleNewsBoxEm articles={allArticles} country={country} em_banner={euro_2020_website_banners_copenhagen} showCompetitionName removeAds/>;
        //pageBody = <ArticleList articles={allArticles} showCompetitionName/>;
        
         console.log(`EM triple-news-competition-name`);
        
      
      // autoArticles and manualArticles is undefined during load.
    }
    return (
      <PageWithoutSidebarsEm topView={topView} wrapInContainer={false} removeAds>
           


              <div className="row">
              <a className="a_sponsor" href={`https://uevents.qualtrics.com/jfe/form/SV_2uvutlZTGOHFleC?Source=Nent&Wave=1`} target="_blank">
              	<img className="em-banner" src={den_930_180} alt="Euro 2020 Copenhagen" />
              </a>
              </div>



        <div className="row news-feed-heading-row">
        
            <div className="template-item col-xs-12">
            	<div className="emheader">
            		<img src={emlogo} alt="Euro 2020" />
            		<PageHeading firstPart='Fodbold' secondPart='EM 2020' />
                </div>
                 
            </div>
        </div>
    
          
        {pageBody}

      </PageWithoutSidebarsEm>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/NewsFeed/Euro2020NewsFeedPage.jsx